// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 31/3/2023
 */

.AddCategory_headingContainer__VDjd\\+ {
    display: flex;
    justify-content: space-between;
}

.AddCategory_closeButton__6hSNQ {
    padding: 0.2rem;
    border: 1px #47C2BB solid;
    color: #47C2BB;
}

.AddCategory_formItem__CugKp {
    margin-top: 1rem;
}

.AddCategory_formLabel__gOZo4 {
    font-weight: 600;
}

.AddCategory_formInput__5CpLn {
    margin-top: 0.3rem;
}

.AddCategory_validation__VaF75 {
    color: red;
}

.AddCategory_buttonContainer__AHJBY {
    margin-top: 2rem;
    margin-bottom: 1rem;
    display: flex;
    justify-content: center;
}

.AddCategory_submitButton__Qhs1W {
    width: 10rem;
}`, "",{"version":3,"sources":["webpack://./src/Components/Category/AddCategory.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;EAoBE;;AAEF;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB","sourcesContent":["/*\r\n * Copyright (c) 2023 by N-Ach (Pvt) Ltd\r\n *\r\n * ╔═╗ ╔╗    ╔═══╗  ╔╗\r\n * ║║╚╗║║    ║╔═╗║  ║║\r\n * ║╔╗╚╝║    ║║ ║╠══╣╚═╗\r\n * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║\r\n * ║║ ║║║╚══╝║╔═╗║╚═╣║║║\r\n * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝\r\n *\r\n * All rights reserved.\r\n *\r\n * This software is the confidential and proprietary information\r\n * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential\r\n * Information and shall use it only in accordance with the terms\r\n * of the license agreement you entered into with N-Ach (Pvt) Ltd.\r\n *\r\n *\r\n * @Author Dilhari Jayathunga\r\n * @Date 31/3/2023\r\n */\r\n\r\n.headingContainer {\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n\r\n.closeButton {\r\n    padding: 0.2rem;\r\n    border: 1px #47C2BB solid;\r\n    color: #47C2BB;\r\n}\r\n\r\n.formItem {\r\n    margin-top: 1rem;\r\n}\r\n\r\n.formLabel {\r\n    font-weight: 600;\r\n}\r\n\r\n.formInput {\r\n    margin-top: 0.3rem;\r\n}\r\n\r\n.validation {\r\n    color: red;\r\n}\r\n\r\n.buttonContainer {\r\n    margin-top: 2rem;\r\n    margin-bottom: 1rem;\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n\r\n.submitButton {\r\n    width: 10rem;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headingContainer": `AddCategory_headingContainer__VDjd+`,
	"closeButton": `AddCategory_closeButton__6hSNQ`,
	"formItem": `AddCategory_formItem__CugKp`,
	"formLabel": `AddCategory_formLabel__gOZo4`,
	"formInput": `AddCategory_formInput__5CpLn`,
	"validation": `AddCategory_validation__VaF75`,
	"buttonContainer": `AddCategory_buttonContainer__AHJBY`,
	"submitButton": `AddCategory_submitButton__Qhs1W`
};
export default ___CSS_LOADER_EXPORT___;
